import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  snippets: {
    overflow: 'hidden',
    display: 'flex',
    gap: theme.spacing(2 * 3.75),
    backgroundColor: theme.palette.background.paper,

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  snippetsFullWidth: {
    flexDirection: 'column',
    padding: 0,
    borderRadius: 0,
  },
}));
